export default __webpack_public_path__ + "static/media/account-page-min.bd416111.jpeg";